import {

  Card,

  Grid,

  Select,

  MenuItem,

  TextField,

  InputLabel,

  FormControl,

  Box,

  Typography,

} from "@mui/material";

import WDBox from "../../../../MaterialComponents/WDBox";

import WDButton from "../../../../MaterialComponents/WDButton";

import WDTypography from "../../../../MaterialComponents/WDTypography";

import AppService from "../../../../Configurations/Appservice";

import apiService from "../../../../services/api";

import { DOCUMENT_TYPE_MAPPING } from "../../../../Configurations/StatFieldData";

import { fetchOrganisationAddress } from "../../../../utils/employeeContextUtils";

import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";



import { Formik, Form, Field } from "formik";

import { object, string } from "yup";

import { useState, useEffect, useRef } from "react";



import FileField from "./panels/FileField";

import FieldText from "./panels/FieldText";

import { useDispatch } from "react-redux";

import {

  showLoader,

  dismissLoader,

  showSuccessMessage,

  showErroMessage,

} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";

import { updateScreenTitle } from "../../../../LayoutContainers/AppLayout/redux/AppSlice";

import WdDivider from "../../../../Components/WdDivider";

import CustomerTextField from "./panels/CustomerStatFieldInfo";

import QuickEmployeeSearch from "../../../../Components/EmployeeSearch/QuickEmployeeSearch";

import QuickEmployeeAddDialog from "../../../../Components/QuickEmployeeAdd/QuickEmployeeAddDialog";

import { Button, Avatar } from "@mui/material";

import { MdPerson } from "react-icons/md";

import AuthenticatedImage from "../../../../Components/AuthenticatedImage";



import { LocalizationProvider } from "@mui/x-date-pickers";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";



dayjs.extend(utc);



const initialValues = {

  customerId: "",

  description: "",

  serviceId: "",



  uid: "",

  firstNameEn: "",

  middleNameEn: "",

  lastNameEn: "",

  firstNameAr: "",

  middleNameAr: "",

  lastNameAr: "",

  nameEn: "",

  nameAr: "",

  dob: null,

  gender: "",

  passportNumber: "",

  passportIssue: "",

  passportExpiry: null,

  passportExpiry2: null,

  passportIssuePlaceEn: "",

  passportIssuePlaceAr: "",

  emiratesId: "",

  emiratesIdIssueDate: null,

  emiratesIdExpiryDate: null,

  birthPlaceEn: "",

  birthPlaceAr: "",

  birthCertificate: "",

  emirate: "",

  medicalLocation: "",

  address: "",

  area: "",

  buildingNumber: "",

  poBox: "",

  mobileNumber: "",

  landNumber: "",

  deliveryNumber: "",

  email: "",

  fileNumber: "",

  passportCopy: "",

  visaPage: "",

  photo: "",

  shinasnama: "",

  labourContract: "",

  salaryCertificate: "",

};



const validationSchema = object({

  serviceId: string().required("Service is Mandatory"),

  customerId: string().required("Customer is Mandatory"),

});



const fieldValues = {};



const OnBeahalfTicket = () => {

  const [services, setServices] = useState([]);

  const [organisation, setOrganisations] = useState([]);

  const [fields, setFields] = useState([]);

  const [chargeMapping, setChargeMapping] = useState();

  const [uploadingStaticDocs, setUploadingStaticDocs] = useState([]);

  const formikRef = useRef();



  const [isUidready, uidReady] = useState(false);

  const [staticFields, setStaticFields] = useState([]);

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [openQuickAddEmployee, setOpenQuickAddEmployee] = useState(false);

  const [selectedOrganizationId, setSelectedOrganizationId] = useState(null);



  const [file, setFile] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [populatedFields, setPopulatedFields] = useState(new Set());

  const [documentReferencesState, setDocumentReferencesState] = useState([]);

  const dispatch = useDispatch();



  // Write newly-uploaded documents back to the employee's document profile just before the ticket is
  // created (mirrors the New Workflow Request form). Files are already on S3 (uploaded at select time);
  // here we bulk-save them so the profile write and the ticket link happen together at submit.
  const syncNewUploadsToEmployeeDocuments = async (values) => {
    try {
      const uid = selectedEmployee?.uid || selectedEmployee?.employeeUid || values.employeeUid || values.uid;
      if (!uid) return;
      const bulkUrl = `/v1/employee-documents/${uid}/bulk`;
      const lastSeg = (p) => (typeof p === 'string' ? p.split('/').pop() : '') || 'Document';
      const multiInstance = new Set(['educationalCertificate', 'experienceCertificate']);
      const staticDocFields = [
        'passportCopy', 'visaPage', 'birthCertificate', 'salaryCertificate', 'labourContract',
        'emiratesId', 'photo', 'shinasnama', 'resume', 'policeClearanceCertificate',
        'educationalCertificate', 'experienceCertificate'
      ];

      for (const code of staticDocFields) {
        const value = values[code];
        if (!value || typeof value !== 'object' || value.isReference) continue;

        // Multiple-instance certificate popup value: bulk-save each titled sub as its own group.
        if (value.isMultiCertificate && Array.isArray(value.subs)) {
          const certBackend = value.backendDocumentType || DOCUMENT_TYPE_MAPPING[code];
          if (!certBackend) continue;
          const allRefs = Array.isArray(value.existingRefs) ? [...value.existingRefs] : [];
          let firstGroupId = allRefs.length ? allRefs[0].documentGroupId : null;
          let primaryDoc = null;
          for (const sub of value.subs) {
            const title = (sub.title || '').trim();
            const files = Array.isArray(sub.files) ? sub.files.filter(f => f.filePath) : [];
            if (!title || files.length === 0) continue;
            try {
              // eslint-disable-next-line no-await-in-loop
              const resp = await apiService.api.post(bulkUrl, {
                documentType: certBackend,
                replaceExisting: false,
                title,
                isReplace: false,
                // Use the certificate name as the saved file name (matching the employee-detail page),
                // suffixing when a certificate holds more than one file.
                documents: files.map((f, idx) => ({ filePath: f.filePath, fileName: files.length > 1 ? `${title} (${idx + 1})` : title, contentType: f.contentType || null, fileSize: f.fileSize || null })),
              }, { headers: { 'Content-Type': 'application/json' } });
              const saved = resp?.data?.data || resp?.data || [];
              const docs = Array.isArray(saved) ? saved : [];
              docs.forEach(d => {
                allRefs.push({ id: d.id, documentId: d.id, fileName: d.fileName, filePath: d.filePath, documentType: code, documentGroupId: d.documentGroupId, isPrimary: !!d.isPrimary });
                if (!firstGroupId) firstGroupId = d.documentGroupId;
                if (!primaryDoc) primaryDoc = d;
              });
            } catch (e) {
              console.warn(`Could not save certificate "${title}" for ${code}; it will be omitted`, e);
            }
          }
          if (allRefs.length > 0) {
            values[code] = {
              isReference: true, documentType: code, backendDocumentType: certBackend, employeeUid: uid,
              id: primaryDoc ? primaryDoc.id : allRefs[0].id, fileName: primaryDoc ? primaryDoc.fileName : allRefs[0].fileName,
              documentGroupId: firstGroupId, hasMultipleFiles: allRefs.length > 1, totalFiles: allRefs.length, documentReferences: allRefs,
            };
          }
          continue;
        }

        // Single-instance raw upload (has a filePath and is not yet a saved group). A multi-file upload
        // (from the multi-select document field) carries all its files in documentReferences with an
        // isNewUpload flag.
        const isNewMultiUpload = value.isNewUpload === true && Array.isArray(value.documentReferences) && value.documentReferences.length > 0;
        const filePath = value.filePath || value.path;
        // Skip values that already reference an employee-profile document (auto-filled from the profile
        // or saved earlier). Freshly staged uploads (isNewUpload) are NOT skipped even though they carry
        // documentReferences.
        const alreadyOnProfile = !isNewMultiUpload && (!!value.documentGroupId ||
          (Array.isArray(value.documentReferences) && value.documentReferences.length > 0));
        if ((!filePath && !isNewMultiUpload) || alreadyOnProfile || multiInstance.has(code)) continue;
        const backendType = DOCUMENT_TYPE_MAPPING[code] || code.replace(/([A-Z])/g, '_$1').toLowerCase();
        if (!backendType) continue;
        const singleInstanceDocs = isNewMultiUpload
          ? value.documentReferences.map(r => ({ filePath: r.filePath, fileName: r.fileName || lastSeg(r.filePath), contentType: r.contentType || null, fileSize: r.fileSize || null }))
          : [{ filePath, fileName: value.fileName || lastSeg(filePath), contentType: value.contentType || value.fileType || null, fileSize: value.fileSize || null }];
        try {
          // eslint-disable-next-line no-await-in-loop
          const resp = await apiService.api.post(bulkUrl, {
            documentType: backendType,
            replaceExisting: true,
            documents: singleInstanceDocs,
          }, { headers: { 'Content-Type': 'application/json' } });
          const saved = resp?.data?.data || resp?.data || [];
          const docs = Array.isArray(saved) ? saved : [];
          if (docs.length === 0) continue;
          const primary = docs.find(d => d.isPrimary) || docs[0];
          values[code] = {
            isReference: true, documentType: code, backendDocumentType: backendType, employeeUid: uid,
            id: primary.id, fileName: primary.fileName || value.fileName || lastSeg(filePath), documentGroupId: primary.documentGroupId,
            documentReferences: docs.map(d => ({ id: d.id, documentId: d.id, fileName: d.fileName, filePath: d.filePath, documentType: code, documentGroupId: d.documentGroupId, isPrimary: !!d.isPrimary })),
          };
        } catch (e) {
          console.warn(`Could not save uploaded ${code} to employee profile; submitting as a plain upload`, e);
        }
      }
    } catch (e) {
      console.warn('syncNewUploadsToEmployeeDocuments failed', e);
    }
  };

  const _onSubmit = async (values, { resetForm }) => {

    // alert(values.passportExpiry);

    // return;

    

    // Prevent double submission

    if (isSubmitting) {

      console.warn('Submission already in progress, ignoring duplicate request');

      return;

    }

    

    console.log(values);

    setIsSubmitting(true);

    dispatch(showLoader());

    // Bulk-save newly uploaded documents to the employee profile just before creating the ticket.
    await syncNewUploadsToEmployeeDocuments(values);

    let obj = {};

    [...fields].forEach((field) => {

      // backend expects Map<UUID, String>. A document/file uploaded for a dynamic field arrives as an
      // object (file metadata), which cannot be deserialized into a String — store its file path so the
      // value is a plain string. Non-object values (text, date strings) pass through unchanged.
      let dynamicFieldValue = field.value;

      if (dynamicFieldValue && typeof dynamicFieldValue === 'object') {

        dynamicFieldValue = dynamicFieldValue.filePath || dynamicFieldValue.path ||
          dynamicFieldValue.documentUrl || dynamicFieldValue.s3Key || dynamicFieldValue.id || '';

      }

      obj[field.id] = dynamicFieldValue;

    });

    values.fields = obj;

    values.uid = selectedEmployee?.uid || selectedEmployee?.employeeUid || "";

    values.onbehalfOf = true;

    

    // Add employeeUid for document associations (same as NewTicket)

    if (selectedEmployee?.uid) {

      values.employeeUid = selectedEmployee.uid;

    }

    if (selectedEmployee?.employeeId) {

      values.employeeId = selectedEmployee.employeeId;

    }



    // Collect document references from Formik values (same approach as NewTicket)
    // Document fields that might contain references to existing documents
    const documentFields = ['passportCopy', 'visaPage', 'birthCertificate', 'salaryCertificate', 'labourContract', 'emiratesId', 'photo', 'shinasnama', 'resume', 'policeClearanceCertificate', 'educationalCertificate', 'experienceCertificate'];
    
    // Get the list of document field names required by the service from staticFields
    // staticFields is an array of field name strings, so filter to only include document fields
    const requiredDocumentFieldNames = staticFields.filter(fieldName => 
      documentFields.includes(fieldName)
    );
    
    console.log('Static fields:', staticFields);
    console.log('Required document fields from staticFields:', requiredDocumentFieldNames);
    
    // Collect document references from Formik values
    const documentReferences = [];
    
    documentFields.forEach(fieldName => {
      const fieldValue = values[fieldName];
      if (!fieldValue || typeof fieldValue !== 'object') return;
      
      // Only include if this field is required by the service
      if (!requiredDocumentFieldNames.includes(fieldName)) {
        console.log(`Skipping ${fieldName} - not required by service`);
        return;
      }
      
      console.log(`Processing document field ${fieldName}:`, {
        documentGroupId: fieldValue.documentGroupId,
        fileName: fieldValue.fileName,
        hasDocumentReferences: !!fieldValue.documentReferences
      });
      
      // If we have grouped document references array (from auto-populate)
      const refs = Array.isArray(fieldValue.documentReferences) ? fieldValue.documentReferences : [];
      if (refs.length > 0) {
        refs.forEach((ref) => {
          if (ref?.documentGroupId) {
            documentReferences.push({
              documentGroupId: ref.documentGroupId,
              documentType: fieldName,
            });
            console.log(`Added document reference from refs array for ${fieldName}:`, ref.documentGroupId);
          }
        });
      } else if (fieldValue.documentGroupId) {
        // Newly uploaded file or auto-populated file with documentGroupId
        documentReferences.push({
          documentGroupId: fieldValue.documentGroupId,
          documentType: fieldValue.documentType || fieldName,
        });
        console.log(`Added document reference for ${fieldName}:`, fieldValue.documentGroupId);
      }
    });
    
    if (documentReferences.length > 0) {
      values.documentReferences = documentReferences;
      console.log('Adding document references to ticket request:', values.documentReferences);
    }

    // Sanitize document fields - backend expects strings, not objects (same as NewTicket)
    documentFields.forEach(fieldName => {
      if (values[fieldName] && typeof values[fieldName] === 'object') {
        // Document fields with metadata should be cleared - they are handled via documentReferences
        console.log(`Clearing document object field ${fieldName} - handled via documentReferences`);
        values[fieldName] = '';
      }
    });

    

    AppService.post("v1/ticket", values)

      .then((response) => {

        resetForm();

        setFields([]);

        setChargeMapping();

        uidReady(false);

        setSelectedEmployee(null);

        setDocumentReferencesState([]);

        setPopulatedFields(new Set());

        const successMessage = `Ticket created successfully! Ticket Number: ${response.ticketNumber || 'N/A'}`;

        dispatch(showSuccessMessage(successMessage));

      })

      .catch((error) => {

        console.error("Error creating ticket:", error);

        dispatch(showErroMessage("Failed to create ticket. Please try again."));

      })

      .finally(() => {

        setIsSubmitting(false);

        dispatch(dismissLoader());

      });

  };



  useEffect(() => {

    dispatch(showLoader());

    const params = {

      type: "CUSTOMER",

    };

    AppService.get("v1/organisation/keyValues", { params })

      .then((response) => {

        setOrganisations(response);

      })

      .catch((error) => {})

      .finally(() => {

        dispatch(dismissLoader());

      });

  }, []);



  useEffect(() => {

    dispatch(updateScreenTitle("On Behalf Of Tickets"));

    return () => dispatch(updateScreenTitle(""));

  }, []);



  const _onOrganisationChange = (event, setFieldValue) => {

    dispatch(showLoader());

    setSelectedOrganizationId(event.target.value);

    setFieldValue("customerId", event.target.value);

    AppService.get("v1/serviceMapping/mappedServices/" + event.target.value)

      .then((response) => {

        setServices(response);

      })

      .catch((error) => {})

      .finally(() => {

        dispatch(dismissLoader());

      });

  };



  const onServieChange = (event, setFieldValue) => {

    dispatch(showLoader());

    setFieldValue("serviceId", event.target.value);

    const params = { serviceId: event.target.value };

    AppService.get("v1/serviceField/byService", { params })

      .then((response) => {

        console.log(response);

        setFields(response.serviceFields);

        setStaticFields(response.staticFields);

        const selectedService = services.find((service) => service.id == event.target.value);

        setChargeMapping(selectedService);

      })

      .catch((error) => {})

      .finally(() => {

        dispatch(dismissLoader());

      });

  };



  const _onTextChange = (text, field, index) => {

    let fieldsCopy = [...fields];

    fieldsCopy.forEach((item) => {

      if (item.id === field.id) {

        item.value = text;

      }

    });

    setFields(fieldsCopy);

  };



  const _onFileUpload = (fileUrl, field) => {
    console.log('=== FILE UPLOAD CALLBACK ===');
    console.log('File uploaded for field:', field?.name, {
      documentGroupId: fileUrl?.documentGroupId,
      documentType: fileUrl?.documentType,
      fileName: fileUrl?.fileName
    });

    let fieldsCopy = [...fields];

    fieldsCopy.forEach((item) => {
      if (item.id === field.id) {
        item.value = fileUrl;
        
        // Store documentGroupId on the field for documentReferences collection
        if (fileUrl?.documentGroupId) {
          item.documentGroupId = fileUrl.documentGroupId;
          console.log(`Stored documentGroupId ${fileUrl.documentGroupId} on field ${item.name}`);
          
          // Also add to documentReferencesState for newly uploaded documents
          setDocumentReferencesState(prev => {
            // Check if this document type already exists
            const existingIndex = prev.findIndex(ref => ref.documentType === field.name);
            const newRef = {
              documentGroupId: fileUrl.documentGroupId,
              documentType: field.name,
              fileName: fileUrl.fileName,
              filePath: fileUrl.filePath,
            };
            
            if (existingIndex >= 0) {
              // Replace existing reference for this document type
              const updated = [...prev];
              updated[existingIndex] = newRef;
              return updated;
            } else {
              // Add new reference
              return [...prev, newRef];
            }
          });
        }
      }
    });

    setFields(fieldsCopy);
    
    // Also update Formik values if formikRef is available
    if (formikRef.current && fileUrl?.documentGroupId) {
      formikRef.current.setFieldValue(field.name, fileUrl);
      console.log(`Updated form field ${field.name} with document metadata`);
    }
  };



  const _onFileRemove = (field) => {
    console.log('Removing file for field:', field?.name);

    let fieldsCopy = [...fields];

    fieldsCopy.forEach((item) => {
      if (item.id === field.id) {
        item.value = null;
        item.documentGroupId = null;
      }
    });

    setFields(fieldsCopy);
    
    // Also remove from documentReferencesState
    setDocumentReferencesState(prev => prev.filter(ref => ref.documentType !== field.name));
    
    // Clear Formik value
    if (formikRef.current) {
      formikRef.current.setFieldValue(field.name, '');
    }
  };



  const _isFieldsAreValid = () => {

    return !fields.some((field) => field.mandatory && !field.value);

  };



  // A dynamic field is a date field when its type is DATE, or (matching the New Workflow Request form's
  // heuristic) when its label/name reads like a date — many services return date fields as plain TEXT,
  // so the name is the only signal. Word-boundary match avoids "update"/"mandate".
  const looksLikeDateField = (field) => {
    if (!field) return false;
    const t = String(field.type || '').toUpperCase();
    if (t === 'DATE') return true;
    if (['FILE', 'PDF', 'DOCUMENT', 'IMAGE'].includes(t)) return false;
    const s = `${field.label || ''} ${field.title || ''} ${field.name || ''} ${field.code || ''}`
      .replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    if (s.includes('number')) return false;
    return /\bdate\b/.test(s);
  };

  const _renderField = (field, index) => {

    if (looksLikeDateField(field)) {

      return (

        <Grid item xs={12} md={6} key={field.id}>

          <WDBox height="100%">

            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DatePicker

                label={field.label || field.title || field.name}

                format="DD-MM-YYYY"

                value={field.value ? dayjs(field.value) : null}

                onChange={(newValue) => {

                  const d = newValue ? dayjs(newValue) : null;

                  _onTextChange(d && d.isValid() ? d.format("YYYY-MM-DD") : "", field, index);

                }}

                slotProps={{

                  textField: {

                    fullWidth: true,

                    required: !!(field.mandatory || field.required),

                  },

                }}

              />

            </LocalizationProvider>

          </WDBox>

        </Grid>

      );

    }

    if (field.type === "TEXT") {

      return (

        <Grid item xs={12} my={1}>

          <WDBox height="100%">

            <FieldText index={index} key={field.id} field={field} onChange={_onTextChange} />

          </WDBox>

        </Grid>

      );

    } else {

      return (

        <Grid item xs={12} md={6}>

          <WDBox height="100%">

            <FileField

              index={index}

              key={field.id}

              field={field}

              onFileUpload={_onFileUpload}

              onFileRemove={_onFileRemove}

              employeeUid={selectedEmployee?.uid || selectedEmployee?.employeeId}

            />

          </WDBox>

        </Grid>

      );

    }

  };



  const dateFields = ["dob", "passportExpiry", "emiratesIdIssueDate", "emiratesIdExpiryDate"];



  // Auto-populate fields from employee documents grouped API (same as NewTicket)

  const autoPopulateFromBackend = async (employeeUid) => {

    const populatedFromGrouped = new Set();

    if (!employeeUid) {

      console.warn('No employee UID provided for auto-population');

      return populatedFromGrouped;

    }



    try {

      console.log('=== AUTOFILL DEBUG: Calling employee documents grouped API for employee:', employeeUid);

      

      const groupedResp = await AppService.get(`v1/employee-documents/${employeeUid}/grouped`);

      console.log('=== AUTOFILL DEBUG: Raw grouped response:', groupedResp);



      const responseData = groupedResp?.data || groupedResp;

      

      if (responseData && responseData.groups && responseData.groups.length > 0) {

        console.log('=== AUTOFILL DEBUG: Employee documents grouped API successful. Groups found:', responseData.groups.length);

        

        const collectedDocumentReferences = [];

        let populatedFieldsCount = 0;

        

        // Document field mapping from document type to form field name

        const documentTypeToFieldName = {

          'passport_copy': 'passportCopy',

          'passportcopy': 'passportCopy',

          'visa_page': 'visaPage',

          'visapage': 'visaPage',

          'birth_certificate': 'birthCertificate',

          'birthcertificate': 'birthCertificate',

          'salary_certificate': 'salaryCertificate',

          'salarycertificate': 'salaryCertificate',

          'labour_contract': 'labourContract',

          'labourcontract': 'labourContract',

          'emirates_id': 'emiratesId',

          'emiratesid': 'emiratesId',

          'photo': 'photo',

          'shinasnama': 'shinasnama',

          'police_clearance_certificate': 'policeClearanceCertificate',

          'policeclearancecertificate': 'policeClearanceCertificate',

          'resume': 'resume',

          'educational_certificate': 'educationalCertificate',

          'educationalcertificate': 'educationalCertificate',

          'experience_certificate': 'experienceCertificate',

          'experiencecertificate': 'experienceCertificate',

        };

        

        responseData.groups.forEach((group, index) => {

          if (group.common && group.common.isCurrent && group.documentGroupId) {

            const documentType = group.common.documentType;

            const documentGroupId = group.documentGroupId;

            

            console.log(`=== AUTOFILL DEBUG: Processing current group - documentType: ${documentType}, documentGroupId: ${documentGroupId}`);

            

            // Find the corresponding field name

            const docTypeLower = documentType.toLowerCase();

            const fieldName = documentTypeToFieldName[docTypeLower] || 

                             documentTypeToFieldName[docTypeLower.replace(/_/g, '')] ||

                             docTypeLower.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());

            

            if (fieldName && group.documents && group.documents.length > 0) {

              console.log(`=== AUTOFILL DEBUG: Found ${group.documents.length} documents for field: ${fieldName}`);

              

              // Create document references for this group

              const documentReferences = group.documents.map(d => ({

                fieldName: fieldName,

                documentGroupId: documentGroupId,

                documentType: fieldName,

                id: d.id,

                documentId: d.id,

                fileName: d.fileName,

                filePath: d.filePath,

                contentType: d.contentType,

                fileSize: d.fileSize,

                isPrimary: !!d.isPrimary,

                uploadDate: d.uploadDate,

              }));

              

              const primaryDoc = group.documents.find(doc => doc.isPrimary) || group.documents[0];

              const fileMetadata = {

                id: primaryDoc.id,

                fileName: primaryDoc.fileName,

                filePath: primaryDoc.filePath,

                contentType: primaryDoc.contentType,

                fileSize: primaryDoc.fileSize,

                documentType: fieldName,

                employeeUid: responseData.uid || employeeUid,

                documentReferences,

                documentGroupId: documentGroupId,

                hasMultipleFiles: group.documents.length > 1,

                totalFiles: group.documents.length

              };

              

              // Set the field value in the form

              if (formikRef.current) {

                formikRef.current.setFieldValue(fieldName, fileMetadata);

                console.log(`=== AUTOFILL DEBUG: Set ${fieldName} with file metadata:`, fileMetadata);

              }

              

              // Collect document reference for submission (will filter at submit time based on service fields)
              collectedDocumentReferences.push({
                documentGroupId: documentGroupId,
                documentType: fieldName,
              });
              console.log(`=== AUTOFILL DEBUG: Added ${fieldName} to documentReferences`);

              

              populatedFromGrouped.add(fieldName);

              populatedFieldsCount++;

            }

          }

        });



        // Multiple-instance certificates (educational/experience) can have several current groups —
        // one per title. The loop above maps each group to a single field and overwrites, so aggregate
        // every current group's documents into one field value so all certificates pre-load.
        try {
          const multiInstanceTargets = [
            { name: 'educationalCertificate', match: (dt) => dt.includes('education') && dt.includes('cert') },
            { name: 'experienceCertificate', match: (dt) => dt.includes('experience') && dt.includes('cert') },
          ];
          const isOnForm = (name) => (Array.isArray(staticFields) && staticFields.includes(name)) || fields.some(f => f.name === name);
          multiInstanceTargets.forEach(({ name, match }) => {
            if (!isOnForm(name)) return;
            const grps = responseData.groups.filter(g => g?.common?.isCurrent && g?.documentGroupId && match((g.common.documentType || '').toLowerCase()));
            if (grps.length === 0) return;
            const refs = [];
            grps.forEach(gr => (Array.isArray(gr.documents) ? gr.documents : []).forEach(d => refs.push({
              id: d.id,
              documentId: d.id,
              fileName: d.fileName,
              filePath: d.filePath,
              documentType: name,
              documentGroupId: gr.documentGroupId,
              isPrimary: !!d.isPrimary,
            })));
            if (refs.length === 0) return;
            const primary = refs.find(r => r.isPrimary) || refs[0];
            if (formikRef.current) {
              formikRef.current.setFieldValue(name, {
                isReference: true,
                documentType: name,
                employeeUid: responseData.uid || employeeUid,
                id: primary.id,
                fileName: primary.fileName || name,
                documentGroupId: primary.documentGroupId,
                hasMultipleFiles: refs.length > 1,
                totalFiles: refs.length,
                documentReferences: refs,
              });
            }
            populatedFromGrouped.add(name);
          });
        } catch (e) {
          console.warn('Multi-instance certificate autofill failed:', e?.message || e);
        }

        // Store document references for submission

        setDocumentReferencesState(collectedDocumentReferences);

        setPopulatedFields(prev => new Set([...prev, ...populatedFromGrouped]));

        

        if (populatedFieldsCount > 0) {

          dispatch(showSuccessMessage(`Auto-populated ${populatedFieldsCount} document fields from employee records`));

        }

      } else {

        console.log('=== AUTOFILL DEBUG: No document groups found for employee');

      }

      

      return populatedFromGrouped;

    } catch (error) {

      console.error('Employee documents API call failed:', error);

      return populatedFromGrouped;

    }

  };

  

  // Handle employee removal/deselection

  const handleEmployeeRemove = () => {

    console.log("Removing selected employee");

    setSelectedEmployee(null);

    uidReady(false);

    

    // Clear all form fields

    if (formikRef.current) {

      const fieldsToReset = [

        'uid', 'firstNameEn', 'middleNameEn', 'lastNameEn',

        'firstNameAr', 'middleNameAr', 'lastNameAr',

        'nameEn', 'nameAr', 'gender', 'dob',

        'passportNumber', 'passportExpiry', 'passportIssue',

        'passportIssuePlaceEn', 'passportIssuePlaceAr',

        'emiratesId', 'emiratesIdIssueDate', 'emiratesIdExpiryDate',

        'birthPlaceEn', 'birthPlaceAr', 'birthCertificate',

        'emirate', 'address', 'area', 'buildingNumber', 'poBox',

        'mobileNumber', 'landNumber', 'deliveryNumber',

        'email', 'fileNumber'

      ];

      

      fieldsToReset.forEach(field => {

        formikRef.current.setFieldValue(field, '');

      });

      

      // Reset date fields to null

      dateFields.forEach(field => {

        formikRef.current.setFieldValue(field, null);

      });

      

      // Reset document fields

      const documentFields = ['passportCopy', 'visaPage', 'birthCertificate', 'salaryCertificate', 'labourContract', 'photo', 'shinasnama'];

      documentFields.forEach(field => {

        formikRef.current.setFieldValue(field, '');

      });

    }

    

    // Clear document references state

    setDocumentReferencesState([]);

    setPopulatedFields(new Set());

  };

  

  // Handle employee selection from QuickEmployeeSearch or QuickEmployeeAdd

  const handleEmployeeSelect = async (employee) => {

    console.log("Employee selected:", employee);

    

    if (!employee) {

      setSelectedEmployee(null);

      uidReady(false);

      return;

    }

    

    const employeeUid = employee.uid || employee.employeeUid || "";

    

    if (!employeeUid) {

      dispatch(showErroMessage("Employee UID not found"));

      return;

    }

    

    try {

      dispatch(showLoader());

      

      // Fetch full employee details from backend

      console.log("Fetching full employee details for UID:", employeeUid);

      const response = await AppService.get(`v1/employees/${employeeUid}`);

      

      console.log("Full employee details response:", response);

      

      // Extract employee data from response

      const fullEmployeeData = response?.data || response || {};

      

      setSelectedEmployee(fullEmployeeData);

      

      // Populate form fields with full employee data

      const employeeData = {

        uid: fullEmployeeData.uid || employeeUid,

        firstNameEn: fullEmployeeData.firstNameEn || fullEmployeeData.firstName || "",

        middleNameEn: fullEmployeeData.middleNameEn || fullEmployeeData.middleName || "",

        lastNameEn: fullEmployeeData.lastNameEn || fullEmployeeData.lastName || "",

        firstNameAr: fullEmployeeData.firstNameAr || "",

        middleNameAr: fullEmployeeData.middleNameAr || "",

        lastNameAr: fullEmployeeData.lastNameAr || "",

        nameEn: fullEmployeeData.fullName || "",

        nameAr: fullEmployeeData.nameAr || "",

        gender: fullEmployeeData.gender || "",

        dob: fullEmployeeData.dob || fullEmployeeData.dateOfBirth || null,

        passportNumber: fullEmployeeData.passportNumber || "",

        passportExpiry: fullEmployeeData.passportExpiry || fullEmployeeData.passportExpiryDate || null,

        passportIssue: (fullEmployeeData.passportIssue || fullEmployeeData.passportIssueDate) 
          ? dayjs(fullEmployeeData.passportIssue || fullEmployeeData.passportIssueDate).format("DD-MM-YYYY") 
          : "",

        passportIssuePlaceEn: fullEmployeeData.passportIssuePlaceEn || "",

        passportIssuePlaceAr: fullEmployeeData.passportIssuePlaceAr || "",

        emiratesId: fullEmployeeData.emiratesId || "",

        emiratesIdIssueDate: fullEmployeeData.emiratesIdIssueDate || null,

        emiratesIdExpiryDate: fullEmployeeData.emiratesIdExpiryDate || null,

        birthPlaceEn: fullEmployeeData.birthPlaceEn || "",

        birthPlaceAr: fullEmployeeData.birthPlaceAr || "",

        birthCertificate: fullEmployeeData.birthCertificate || "",

        emirate: fullEmployeeData.emirate || "",

        // Address comes from the customer organisation, not the employee —
        // overridden after the forEach below via fetchOrganisationAddress().
        address: "",

        area: fullEmployeeData.area || "",

        buildingNumber: fullEmployeeData.buildingNumber || "",

        poBox: fullEmployeeData.poBox || "",

        mobileNumber: fullEmployeeData.mobileNumber || fullEmployeeData.phone || "",

        landNumber: fullEmployeeData.landNumber || "",

        deliveryNumber: fullEmployeeData.deliveryNumber || "",

        email: fullEmployeeData.email || "",

        fileNumber: fullEmployeeData.fileNumber || "",

        nationality: fullEmployeeData.nationality || "",

      };

      

      // Set form values

      Object.keys(employeeData).forEach((key) => {

        if (dateFields.includes(key) && employeeData[key]) {

          formikRef.current.setFieldValue(

            key,

            dayjs.utc(employeeData[key], "YYYY-MM-DD").local()

          );

        } else {

          formikRef.current.setFieldValue(key, employeeData[key]);

        }

      });

      

      uidReady(true);

      // Auto-fill the 'address' field from the selected customer
      // organisation (not the employee). Light fetch — uses bare
      // TOrganisation, not TTicketOrgDetails.
      try {
        const orgAddress = await fetchOrganisationAddress(selectedOrganizationId);
        if (orgAddress) {
          formikRef.current.setFieldValue("address", orgAddress);
        }
      } catch (e) {
        console.warn("Failed to auto-fill address from organisation:", e?.message || e);
      }

      // Auto-populate document fields from employee documents grouped API

      await autoPopulateFromBackend(employeeUid);

      

      dispatch(showSuccessMessage("Employee details loaded successfully"));

    } catch (error) {

      console.error("Error fetching employee details:", error);

      dispatch(showErroMessage("Failed to fetch employee details. Please try again."));

      setSelectedEmployee(null);

      uidReady(false);

    } finally {

      dispatch(dismissLoader());

    }

  };



  const _onStaticFieldDocUpload = (formikField) => {

    let uploadingStaticDocsCopy = [...uploadingStaticDocs];

    uploadingStaticDocsCopy.push(formikField);

    setUploadingStaticDocs(uploadingStaticDocsCopy);

  };



  const _onStaticFieldDocUploadComplete = (formikField) => {

    let uploadingStaticDocsCopy = [...uploadingStaticDocs].filter((item) => item !== formikField);

    setUploadingStaticDocs(uploadingStaticDocsCopy);

  };



  function onKeyDown(keyEvent) {

    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {

      keyEvent.preventDefault();

    }

  }



  return (

    <WDBox py={1}>

      <Card sx={{ padding: 3 }}>

        <Formik

          initialValues={initialValues}

          onSubmit={_onSubmit}

          validationSchema={validationSchema}

          innerRef={formikRef}

        >

          {({ errors, isValid, touched, dirty, setFieldValue, values, setFieldTouched }) => (

            <Form onKeyDown={onKeyDown}>

              <WDBox>

                <WDTypography fontSize={14}>Basic Details</WDTypography>

              </WDBox>

              <WDBox my={3}>

                <Grid container spacing={3}>

                  <Grid item xs={12}>

                    <WDBox>

                      <FormControl fullWidth>

                        <InputLabel id="customer-label">Customer Organisation</InputLabel>

                        <Field

                          name="customerId"

                          label="Cusomer Organisation"

                          labelId="customer-label"

                          size="small"

                          fullWidth

                          as={Select}

                          onChange={(e) => _onOrganisationChange(e, setFieldValue)}

                          error={Boolean(errors.serviceId) && Boolean(touched.serviceId)}

                          helperText={Boolean(touched.serviceId) && errors.serviceId}

                        >

                          {organisation.map((service) => (

                            <MenuItem value={service.id}>{service.name}</MenuItem>

                          ))}

                        </Field>

                      </FormControl>

                    </WDBox>

                  </Grid>

                  <Grid item xs={12}>

                    <WDBox>

                      <FormControl fullWidth>

                        <InputLabel id="service-label">Service</InputLabel>

                        <Field

                          name="serviceId"

                          label="Service"

                          labelId="service-label"

                          size="small"

                          fullWidth

                          disabled={!values.customerId}

                          as={Select}

                          onChange={(e) => onServieChange(e, setFieldValue)}

                          error={Boolean(errors.serviceId) && Boolean(touched.serviceId)}

                          helperText={Boolean(touched.serviceId) && errors.serviceId}

                        >

                          {services.map((service) => (

                            <MenuItem value={service.id}>{service.name}</MenuItem>

                          ))}

                        </Field>

                      </FormControl>

                    </WDBox>

                  </Grid>

                  <Grid item xs={12}>

                    <WDBox>

                      <Field

                        name="description"

                        label="Ticket Description"

                        fullWidth

                        as={TextField}

                        size="small"

                        multiline

                        maxRows={2}

                        error={Boolean(errors.description) && Boolean(touched.description)}

                        helperText={Boolean(touched.description) && errors.description}

                      />

                    </WDBox>

                  </Grid>

                </Grid>

              </WDBox>



              <Typography fontSize={14}>Customer Details</Typography>

              <Box sx={{ pt: 2 }}>

                {!selectedEmployee ? (

                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>

                    <Box sx={{ 

                      flex: 1,

                      opacity : selectedOrganizationId ? 1 : 0.6,

                      pointerEvents: selectedOrganizationId ? 'auto' : 'none',

                      }}>

                      <QuickEmployeeSearch

                        selectedEmployee={null}

                        onEmployeeSelect={handleEmployeeSelect}

                        organizationId={selectedOrganizationId}

                      />

                    </Box>

                    <Button

                      variant="outlined"

                      onClick={() => setOpenQuickAddEmployee(true)}

                      disabled={!selectedOrganizationId}

                      sx={{

                        minWidth: 'auto',

                        height: '56px',

                        px: 2,

                        borderRadius: '10px',

                        borderColor: '#00838f',

                        color: '#00838f',

                        textTransform: 'none',

                        fontWeight: 600,

                        transition: 'all 0.3s ease',

                        '&:hover': {

                          borderColor: '#00838f',

                          backgroundColor: 'rgba(0,131,143,0.04)',

                          boxShadow: '0 0 0 3px rgba(0,131,143,0.1)'

                        }

                      }}

                    >

                      Quick Add

                    </Button>

                  </Box>

                ) : (

                  /* Custom Sleek Selected Employee Display when employee is selected */

                  <Box sx={{

                    display: 'flex',

                    alignItems: 'center',

                    p: 2,

                    borderRadius: '8px',

                    backgroundColor: '#f5f9fc',

                    border: '1px solid #e1f5fe',

                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',

                  }}>

                    {/* Employee Photo */}

                    <Avatar

                      sx={{

                        width: 40,

                        height: 40,

                        mr: 2,

                        bgcolor: '#00838f',

                        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',

                        position: 'relative',

                        overflow: 'hidden'

                      }}

                    >

                      {/* Employee photo with proper authentication */}

                      {selectedEmployee.photo ? (

                        <Box

                          sx={{

                            position: 'absolute',

                            top: 0,

                            left: 0,

                            width: '100%',

                            height: '100%',

                            display: 'flex',

                            alignItems: 'center',

                            justifyContent: 'center'

                          }}

                        >

                          <AuthenticatedImage

                            src={selectedEmployee.photo}

                            alt={`${selectedEmployee.nameEn || selectedEmployee.firstNameEn || 'Employee'} photo`}

                            employeeId={selectedEmployee.uid || selectedEmployee.employeeId || ''}

                            maxSize={80}

                            style={{

                              width: '100%',

                              height: '100%',

                              objectFit: 'cover',

                              borderRadius: '50%'

                            }}

                          />

                        </Box>

                      ) : (

                        <MdPerson size={24} />

                      )}

                    </Avatar>

                    

                    {/* Employee Details */}

                    <Box sx={{ flexGrow: 1 }}>

                      <Typography sx={{ fontWeight: 600, fontSize: '0.95rem', color: '#263238' }}>

                        {selectedEmployee.nameEn || 

                         `${selectedEmployee.firstNameEn || ''} ${selectedEmployee.lastNameEn || ''}`}

                      </Typography>

                      <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>

                        {selectedEmployee.uid && (

                          <Typography variant="caption" sx={{ color: '#0277bd', fontWeight: 500 }}>

                            UID: {selectedEmployee.uid}

                          </Typography>

                        )}

                        {selectedEmployee.mobileNumber && (

                          <Typography variant="caption" sx={{ color: '#00796b', fontWeight: 500 }}>

                            {selectedEmployee.mobileNumber}

                          </Typography>

                        )}

                      </Box>

                    </Box>

                    

                    {/* Change Employee Button */}

                    <Button

                      size="small"

                      variant="outlined"

                      onClick={handleEmployeeRemove}

                      sx={{

                        minWidth: 'auto',

                        ml: 1,

                        fontSize: '0.75rem',

                        textTransform: 'none',

                        borderRadius: '4px',

                        py: 0.5,

                        px: 1,

                        color: '#000000',

                        borderColor: '#000000'

                      }}

                    >

                      Change

                    </Button>

                  </Box>

                )}

              </Box>

              <CustomerTextField

                staticFields={staticFields}

                isUidready={isUidready}

                formikRef={formikRef}

                setFieldValue={setFieldValue}

                uploadingDocs={uploadingStaticDocs}

                onUpload={_onStaticFieldDocUpload}

                onUploadComplete={_onStaticFieldDocUploadComplete}

                formikValues={values}

                employeeUid={selectedEmployee?.uid || selectedEmployee?.employeeId}

                onDocumentUploaded={(docRef) => {
                  // Add newly uploaded document to documentReferencesState
                  if (docRef?.documentGroupId) {
                    setDocumentReferencesState(prev => {
                      const existingIndex = prev.findIndex(ref => ref.documentType === docRef.documentType);
                      if (existingIndex >= 0) {
                        const updated = [...prev];
                        updated[existingIndex] = docRef;
                        return updated;
                      }
                      return [...prev, docRef];
                    });
                  }
                }}

              />



              {/* {_renderCustomerDetails(errors, isValid, touched, dirty, setFieldValue)} */}

              <Typography fontSize={14}>More Details</Typography>

              <WDBox my={2}>

                <Grid container spacing={1}>

                  {fields

                    .filter((item) => item.type === "TEXT" || looksLikeDateField(item))

                    .map((field, index) => _renderField(field, index))}

                </Grid>

              </WDBox>

              <Typography fontSize={14}>Documents</Typography>

              <WDBox>

                <Grid container spacing={1}>

                  {fields

                    .filter((item) => item.type != "TEXT" && !looksLikeDateField(item))

                    .map((field, index) => _renderField(field, index))}

                </Grid>

              </WDBox>

              {chargeMapping && (

                <WDBox my={6}>

                  <WdDivider>

                    <Typography fontSize={14}>Charges</Typography>

                  </WdDivider>

                  <Grid container spacing={3}>

                    <Grid item xs={12} md={3}>

                      <Box>

                        <WDTypography variant="caption">Govt.Charge</WDTypography>

                        <WDTypography variant="h6" fontSize={14}>

                          {chargeMapping.govtCharge}

                        </WDTypography>

                      </Box>

                    </Grid>

                    <Grid item xs={12} md={3}>

                      <Box>

                        <WDTypography variant="caption">Service Charge</WDTypography>

                        <WDTypography variant="h6" fontSize={14}>

                          {chargeMapping.serviceCharge}

                        </WDTypography>

                      </Box>

                    </Grid>

                    <Grid item xs={12} md={3}>

                      <Box>

                        <WDTypography variant="caption">Tax On Service Charge</WDTypography>

                        <WDTypography variant="h6" fontSize={14}>

                          {chargeMapping.taxOnServiceCharge}

                        </WDTypography>

                      </Box>

                    </Grid>

                  </Grid>

                </WDBox>

              )}

              <WDBox display="flex" justifyContent="flex-end" pt={3}>

                <WDButton

                  variant="gradient"

                  disabled={!dirty || !isValid || !_isFieldsAreValid() || isSubmitting}

                  type="submit"

                >

                  {isSubmitting ? 'Submitting...' : 'Submit'}

                </WDButton>

              </WDBox>

            </Form>

          )}

        </Formik>

      </Card>

      

      {/* Quick Employee Add Dialog */}

      <QuickEmployeeAddDialog

        open={openQuickAddEmployee}

        onClose={() => setOpenQuickAddEmployee(false)}

        onEmployeeAdded={handleEmployeeSelect}

        organizationId={selectedOrganizationId}

      />

    </WDBox>

  );

};



export default OnBeahalfTicket;

